import VoicemailForm from 'react-components/admin-dashboard/components/user-creation/CreateEditUser/VoicemailForm';
import { BaseDialog } from '../../stories/dialogs/shared/components/BaseDialog';
import { selectActingUser } from 'redux/slices/actingUserSlice';
import { UserDto } from '@act/shared/data-transfer-objects';
import { useAppSelector } from 'redux/store-hooks';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const VoicemailFormDialog = ({ open, handleClose }: Props) => {
  const actingUser: UserDto = useAppSelector(selectActingUser);
  return (
    <BaseDialog open={open} setOpen={handleClose}>
      <VoicemailForm
        userId={actingUser?.id}
        userVoicemailFileId={actingUser?.voicemailGreetingFileId}
      />
    </BaseDialog>
  );
};

export default VoicemailFormDialog;
